document.addEventListener('scroll', function () {
  const header = document.querySelector('.site-header'); // Replace with your header's class
  const menuLinks = document.querySelectorAll('.site-nav__link'); // Replace with your menu link class

  if (window.scrollY > 50) {
    // Change header background color to black
    header.style.backgroundColor = '#000'; 
    header.style.transition = 'background-color 0.3s';

    // Change menu link colors to white
    menuLinks.forEach(link => {
      link.style.color = '#fff';
    });
  } else {
    // Revert header background color to transparent
    header.style.backgroundColor = 'transparent';

    // Revert menu link colors to the original color
    menuLinks.forEach(link => {
      link.style.color = '#000'; // Original menu color
    });
  }
});
